import React from "react";

import { Icon } from "@culturehq/components";
import { Trans } from "app/utils";
import SelectedStories from "./SelectedStories";

const DisplayStories = ({ selectedStories }) => {
  if (selectedStories?.length > 0) {
    return <SelectedStories selectedStories={selectedStories} />;
  }

  return (
    <div className="EmptyState--container">
      <div className="Approve-Button--icon__container">
        <Icon className="Approve-Button--icon" icon="tale" />
      </div>
      <Trans>
        No stories have been selected for your page yet.
        <br />
        Select from any story that has been shared in CultureHQ.
      </Trans>
    </div>
  );
};

export default DisplayStories;
